<section class="pt-16 px-container">
    <h1 class="text-5xl md:text-6xl">Informativa sul trattamento dei dati personali</h1>
</section>

<section class="py-16 mb-8 px-container text-justify">
    <p>
        Caro Utente,
        la normativa in materia di privacy, il cui rispetto ci sta particolarmente a cuore, ci richiede di
        fornirti le seguenti informazioni sul trattamento dei tuoi dati personali.
        <br />Il “trattamento di dati personali”, in parole semplici, è una qualsiasi operazione
        riguardante qualunque “informazione relativa a persona fisica, identificata o
        identificabile”. Ad esempio, un indirizzo e-mail di una persona è considerato “dato
        personale”, e l’atto di raccoglierlo e registrarlo presso di noi è considerato
        “trattamento”; così anche (sempre ad esempio) la comunicazione ad altri soggetti e la
        cancellazione.
        <br />La nostra organizzazione è definita “titolare del trattamento”, perché stabiliamo come
        e per quali finalità trattare informazioni relative a persone fisiche.
        <br />Tu, in quanto persona fisica a cui si riferiscono i dati personali, sei definito
        “interessato”, e hai diritto di ricevere le seguenti informazioni su chi siamo, sul perché,
        su come e per quanto tempo li trattiamo, e su quali obblighi e diritti tu hai in merito.
        <br />Nel caso in cui tu ti limiti a navigare sul nostro sito, non raccoglieremo informazioni che
        possano identificarti (e pertanto non tratteremo dati personali, ma solo “dati di
        navigazione”).
    </p>
    <h5 class="my-5 font-bold">“Dati di Navigazione”:</h5>
    <p>sono i dati che i sistemi
        informatici e le procedure software preposte al funzionamento del sito acquisiscono, nel corso
        del loro normale esercizio, e la cui trasmissione è implicita nell'uso dei protocolli di comunicazione
        di Internet. Si tratta di informazioni che non
        sono raccolte per essere associate a interessati identificati, ma che per loro stessa natura potrebbero,
        attraverso elaborazioni ed associazioni con
        dati detenuti da terzi, permettere di identificare gli utenti. In questa categoria di dati rientrano gli
        indirizzi IP o i nomi a dominio dei computer
        utilizzati dagli utenti che si connettono al sito, gli indirizzi in notazione URI (Uniform Resource
        Identifier) delle risorse richieste, l'orario della
        richiesta, il metodo utilizzato nel sottoporre la richiesta al server, la dimensione del file ottenuto
        in risposta, il codice numerico indicante lo stato
        della risposta data dal server (buon fine, errore, ecc.) ed altri parametri relativi al sistema
        operativo e all'ambiente informatico dell'utente. Questi
        dati vengono utilizzati al solo fine di ricavare informazioni statistiche anonime sull'uso del sito e
        per controllarne il corretto funzionamento e
        vengono cancellati immediatamente dopo l'elaborazione.</p>

    <h5 class="my-5 font-bold">Chi siamo?</h5>
    <p>Colosseo srl, con sede legale in Torino, Via Madama Cristina 71, C.F. e P.I.04092480013 (“Titolare del
        Trattamento”).</p>

    <h5 class="my-5 font-bold">Perché trattiamo dati personali (finalità)?</h5>
    <p>Per:</p>
    <ul>
        <li>a) soddisfare le tue richieste in merito alla nostra attività;</li>
        <li>b) eseguire le nostre prestazioni in tuo favore;</li>
        <li>c) inviarti informazioni sulla nostra attività (ad es. mediante la newsletter);</li>
        <li>d) adempiere ad obblighi di legge (ad es. di carattere amministrativo e contabile) e/o ottemperare
            ad ordini provenienti da pubbliche autorità;</li>
        <li>e) accertare, esercitare e/o difendere un diritto nelle sedi competenti.</li>
    </ul>


    <h5 class="my-5 font-bold">Su cosa si fonda il trattamento (base giuridica)?</h5>
    <p>Almeno una delle seguenti:</p>
    <ul>
        <li>la necessità di svolgere le nostre prestazioni in tuo favore;</li>
        <li>il dovere di adempiere ad obblighi di legge;</li>
        <li>il nostro interesse legittimo (ad es. a mandarti informazioni sulla nostra attività, se sei già
            nostro cliente);</li>
        <li>il tuo consenso liberamente prestato e revocabile in qualunque momento (per le informazioni sulla
            nostra attività, se non sei già nostro cliente).</li>
    </ul>

    <h5 class="my-5 font-bold">A chi comunichiamo i dati (categorie di destinatari)?</h5>
    <ul>
        <li>a) fornitori di servizi necessari all’esecuzione delle nostre prestazioni (ad es. informatici,
            bancari, assicurativi, di spedizione e trasporto, ecc.);</li>
        <li>b) soggetti da noi autorizzati (es. nostri lavoratori);</li>
        <li>c) organizzazioni pubbliche.
            <br />Non diffondiamo alcun dato.
        </li>
    </ul>

    <h5 class="my-5 font-bold">Per quanto tempo conserviamo i dati?</h5>
    <p>Salvo che la legge ci imponga (o ci consenta) di non cancellare i dati, ci comportiamo come segue:</p>
    <ul>
        <li>se ci comunichi dati per consentirci di eseguire le nostre prestazioni in tuo favore, il tempo
            massimo di conservazione è di 10 anni dal termine dell’esecuzione della prestazione;</li>
        <li>se ci comunichi i dati solo per essere informato sulle nostre attività, li cancelliamo entro 24
            mesi.</li>
    </ul>

    <h5 class="my-5 font-bold">Sei obbligato a fornirci i dati personali?</h5>
    <p>Per consentirci di eseguire le nostre prestazioni in tuo favore, devi fornirceli, perché sono necessari
        ai fini del contratto.
        <br />Se vuoi soltanto essere informato sulle nostre attività, nonsei obbligato.
    </p>


    <h5 class="my-5 font-bold">Cosa accade se rifiuti di comunicare i tuoi dati?</h5>
    <p>La conseguenza è almeno una delle seguenti:</p>
    <ul>
        <li>a) non potremo eseguire le nostre prestazioni in tuo favore;</li>
        <li>b) non potremo informarti sulla nostra attività.</li>
    </ul>


    <h5 class="my-5 font-bold">Quali diritti hai?</h5>
    <p>Tu hai diritto di:</p>
    <ul>
        <li>a) accedere ai tuoi dati in nostro possesso;
        <li>b) chiederne la rettifica e/o la cancellazione (“oblio”), ove ricorrano i presupposti;</li>
        <li>c) chiedere la limitazione del trattamento, ove ricorrano i presupposti;</li>
        <li>d) opporti al trattamento, ove vi siano i presupposti;</li>
        <li>e) revocare il consenso al trattamento per finalità commerciali;</li>
        <li>f) richiedere la portabilità dei dati, ove tecnicamente possibile;</li>
        <li>g) proporre reclamo al Garante per la Protezione dei Dati Personali (in Italia, <a
                href="https://www.garanteprivacy.it/" target="_blank">www.garanteprivacy.it</a>), o all’Autorità
            Garante dello Stato dell’UE in cui risiedi abitualmente o lavori, oppure del luogo ove si è
            verificata la presunta violazione.</li>
    </ul>
    <h5 class="my-5 font-bold">Se hai dubbi e/o domande sul trattamento dei tupi dati, cosa puoi fare?</h5>
    <p>Ci puoi contattare ai seguenti recapiti:<br />e-mail <a href="mailto:privacy@teatrocolosseo.it"
            title="mail">privacy&#64;teatrocolosseo.it</a>;<br />telefono 011 6698034 - 011 6505195</p>

    <p>
        Questo atto di informazione è in vigore dal 1 giugno 2018; ci riserviamo di modificarne il contenuto, in
        parte o completamente, anche a causa di variazioni della normativa in materia di privacy; pubblicheremo
        la versione aggiornata, che da quel momento sarà vincolante: sei quindi invitato a visitare con
        regolarità questa sezione.
    </p>


    <h1 class="lg:text-6xl text-4xl my-16">Cookie Policy</h1>
    <p>
        Questo sito utilizza cookie per le seguenti finalità: esecuzione di autenticazioni informatiche,
        monitoraggio di sessioni, memorizzazione di informazioni su specifiche configurazioni riguardanti gli
        utenti che accedono al server.
        <br />Il presente documento fornisce informazioni dettagliate sull’uso dei cookie e di tecnologie
        simili, su come sono utilizzati sul sito e su come gestirli.
        <br />Hai la possibilità di configurare il tuo browser in modo da essere avvisato della ricezione dei
        cookie o rifiutarli. L’accettazione dei cookie da parte del browser può essere disabilitata attraverso
        la modifica delle suddette impostazioni.
        <br />In generale, l’utilizzo di cookie da parte nostra non comporta il trattamento di dati personali,
        perché adottiamo soluzioni tecniche che non ci consentono di identificarti.
    </p>
    <h5 class="my-5 font-bold">1. Definizione</h5>
    <p>I cookie sono brevi frammenti di testo (lettere e/o numeri) che permettono al server web di memorizzare
        sul browser informazioni da riutilizzare nel corso della medesima visita al sito (cookie di sessione) o
        in seguito, anche a distanza di giorni (cookie persistenti). I cookie vengono memorizzati, in base alle
        preferenze dell’utente, dal singolo browser sullo specifico dispositivo utilizzato (computer, tablet,
        smartphone).</p>

    <h5 class="my-5 font-bold">2.Tipologie di cookie</h5>
    <p><br />2.1. Esistono diverse categorie di cookie, con caratteristiche e utilizzi diversi:</p>
    <ul>
        <li> a) Cookie tecnici: si tratta di cookie indispensabili per il corretto funzionamento del sito e sono
            utilizzati al solo fine di effettuare la trasmissione di una comunicazione su una rete di
            comunicazione elettronica, o nella misura strettamente necessaria al fornitore di un servizio della
            società dell’informazione esplicitamente richiesto dall’abbonato o dall’Utente a erogare tale
            servizio;</li>
        <li> b) Cookie analitici: sono cookie utilizzati per raccogliere e analizzare il traffico e l’utilizzo
            del sito in modo anonimo. Questi cookie, pur senza identificare l’utente, consentono, per esempio,
            di rilevare se il medesimo utente torna a collegarsi in momenti diversi. Permettono inoltre di
            monitorare il sistema e migliorarne le prestazioni e l’usabilità. La disattivazione di tali cookie
            può essere eseguita senza alcuna perdita di funzionalità.</li>
        <li> c) Cookie di profilazione: si tratta di cookie persistenti utilizzati per identificare (in modo
            anonimo e non) le preferenze dell’utente e migliorare la sua esperienza di navigazione.</li>
        <li> d) Cookie di terze parti (analitici e/o di profilazione): si tratta di cookie generati da
            organizzazioni non facenti capo al Sito, ma integrati in parti della pagina del Sito. Si pensi ad
            esempio ai “widget” di Google (ad es. Google Maps) o ai “social plugin” (Facebook, Twitter,
            LinkedIn, Google+, ecc.).</li>
    </ul>
    <p><br />2.2. La gestione delle informazioni raccolte da “terze parti” è disciplinata dalle relative
        informative cui si prega di fare riferimento, e che per comodità sono indicate nei link riportati di
        seguito.</p>

    <h5 class="my-5 font-bold">3. Tipologie di cookie utilizzati</h5>
    <p><br />3.1. Il Sito utilizza i seguenti cookie:</p>
    <ul>
        <li> a) tecnici sviluppati internamente.</li>
        <li> b) Analitici sviluppati internamente: AUTH, ATUVS, ATUVC.</li>
        <li> c) analitici di terze parti: Google Analytics, un servizio di analisi del traffico web fornito da
            Google, Inc. (“Google”), che consente di analizzare delle dettagliate statistiche
            sui visitatori di un sito web. Adottiamo strumenti per ridurre il potere identificativo dei cookie
            (anonimizzazione dell'IP: illustrazione del funzionamento tecnico all'indirizzo
            <a href="https://support.google.com/analytics/answer/2763052?hl=it"
                target="_blank">https://support.google.com/analytics/answer/2763052?hl=it</a>) e abbiamo
            configurato il servizio in modo da impedire l'associazione
            della rimanente porzione dell’indirizzo IP ad altri dati posseduti da Google (<a
                href="https://support.google.com/analytics/answer/3379636?hl=it"
                target="_blank">https://support.google.com/analytics/answer/3379636?hl=it</a>);
            abbiamo inoltre implementato i controlli per la conservazione dei dati, impostando il periodo a 26
            mesi (<a href="https://support.google.com/analytics/answer/7667196?hl=it"
                target="_blank">https://support.google.com/analytics/answer/7667196?hl=it</a>).
            Per ulteriori informazioni, si rinvia al link <a href="https://www.google.it/policies/privacy/partners/"
                target="_blank">https://www.google.it/policies/privacy/partners/</a> .
            L’utente può disabilitare in modo selettivo l’azione di Google Analytics installando sul proprio
            browser il componente di opt-out fornito da Google (si rinvia al link
            <a href="https://tools.google.com/dlpage/gaoptout"
                target="_blank">https://tools.google.com/dlpage/gaoptout</a>).
        </li>
    </ul>

    <h5 class="my-5 font-bold">4. Durata</h5>
    <p><br />4.1. Alcuni cookie restano attivi solo fino alla chiusura del browser. Altri cookie (c.d. cookie
        persistenti) “sopravvivono” alla chiusura del browser e sono disponibili anche in successive visite, e
        la loro durata è fissata dal server al momento della loro creazione; in alcuni casi è fissata una
        scadenza, in altri casi la durata è illimitata, ma puoi sempre cancellarli dalle Impostazioni del
        browser.</p>
    <p><br />4.2. I cookie tecnici utilizzati vengono cancellati automaticamente dopo 24 ore; il cookie AUTH
        persiste un giorno, il cookie ATUVS persiste 30 minuti, il cookie ATUVC persiste 30 giorni.</p>


    <h5 class="my-5 font-bold">5. Gestione</h5>
    <p><br />5.1. Puoi decidere se accettare o meno i cookie utilizzando le impostazioni del tuo browser.</p>
    <p><br />5.2. La fruibilità dei contenuti è possibile anche disabilitando completamente i cookie, ad
        eccezione di quelli “di sessione” nel caso in cui l’Utente voglia autenticarsi sull’area riservata (ove
        presente), e la disabilitazione dei cookie “terze parti” non pregiudica in alcun modo la navigabilità
        del Sito.</p>
    <p><br />5.3. L’impostazione può essere definita in modo specifico per i diversi siti e applicazioni web.
        Inoltre i migliori browser consentono di definire impostazioni diverse per vari tipi i cookie</p>
    <ul>
        <li> a) Firefox: <a href="https://support.mozilla.org/it/kb/Gestione%20dei%20cookie"
                target="_blank">https://support.mozilla.org/it/kb/Gestione%20dei%20cookie</a></li>
        <li>b) Internet Explorer: <a
                href="https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies"
                target="_blank">https://support.microsoft.com/it-it/help/17442/windows-internet-explorer-delete-manage-cookies</a>
        </li>
        <li>c) Chrome: <a href="https://support.google.com/chrome/answer/95647?hl=it"
                target="_blank">https://support.google.com/chrome/answer/95647?hl=it</a></li>
        <li>d) Opera: <a href="http://help.opera.com/Windows/10.00/it/cookies.html"
                target="_blank">http://help.opera.com/Windows/10.00/it/cookies.html</a></li>
        <li>e) Safari per Mac: <a href="https://support.apple.com/kb/PH21411?viewlocale=it_IT&locale=it_IT"
                target="_blank">https://support.apple.com/kb/PH21411?viewlocale=it_IT&locale=it_IT</a></li>
        <li>f) Safari per iOS: <a href="http://support.apple.com/kb/HT1677?viewlocale=it_IT"
                target="_blank">http://support.apple.com/kb/HT1677?viewlocale=it_IT</a></li>
    </ul>
    <p><br />5.4. Segnaliamo inoltre la possibilità di utilizzare strumenti appositi per la gestione della
        privacy riguardante i cookies a fini pubblicitari come Your Online Choices
        (<a href="http://www.youronlinechoices.com/it/" target="_blank">http://www.youronlinechoices.com/it/</a>)
        limitatamente ai network pubblicitari che
        aderiscono
        all'iniziativa. Per ulteriori informazioni, <a href="http://www.edaa.eu" target="_blank">http://www.edaa.eu</a>.
    </p>

</section>